// @flow
import { OpinometroActionTypes } from './constants';

type OpinometroAction = { type: string, payload: {} | string };

// common success
export const opinometroApiResponseSuccess = (actionType: string, data: any): OpinometroAction => ({
    type: OpinometroActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const opinometroApiResponseError = (actionType: string, error: string): OpinometroAction => ({
    type: OpinometroActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getOpinometro = (id: string): OpinometroAction => ({
    type: OpinometroActionTypes.GET_OPINOMETRO,
    payload: { id },
});

export const addOpinometro = (opinometro: any): OpinometroAction => ({
    type: OpinometroActionTypes.ADD_OPINOMETRO,
    payload: opinometro
})
export const duplicateOpinometro = (opinometro: any): OpinometroAction => ({
    type: OpinometroActionTypes.DUPLICATE_OPINOMETRO,
    payload: opinometro
})
export const updateOpinometro = (opinometro: any): OpinometroAction => ({
    type: OpinometroActionTypes.UPDATE_OPINOMETRO,
    payload: opinometro
})
export const deleteOpinometro = (id: string): OpinometroAction => ({
    type: OpinometroActionTypes.DELETE_OPINOMETRO,
    payload: { id }
})

export const listOpinometro = (params: any): OpinometroAction => ({
    type: OpinometroActionTypes.LIST_OPINOMETROS,
    payload: params,
});


export const resetOpinometro = (): OpinometroAction => ({
    type: OpinometroActionTypes.RESET,
    payload: {},
});

